<template>
  <div class="box bg-white flex justify-center items-center">
    <div class="w-11/12 md:w-8/12 flex wrap justify-center">
      <div class="w-9/12 md:w-5/12">
        <img src="@/assets/images/accounting/no-subscription.svg" class="mr-1"/>
      </div>
      <div class="w-full md:w-7/12">
        <p class="text-xs">
          Your current subscription does not include the Purchase Module. You
          can upgrade your subscritpion to get data here automatically or add
          your sales data manually.
        </p>
        <p class="my-3">
          <button class="text-primary-yellow mr-4 text-sm">Add Purchase Data</button>
          <button class="text-primary-green text-sm">Import from File</button>
        </p>
        <p>
          <button>Upgrade Subscription</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
};
</script>

<style lang="scss" scoped>
 .box{
    height: 400px
 }
</style>
